import { Modal } from 'antd';
import type { ReactNode } from 'react';
import { sizeToWidth } from './sizeToWidth';

interface DialogModalProps {
  /** Optional detail below the title; a title-only question is a valid dialog. */
  dialog?: string | ReactNode;
  title: string;
  size?: 'sm' | 'lg' | 'xl';
  aktionButtonLabel?: ReactNode;
  cancelButtonLabel?: ReactNode;
  cancelErrorMessage?: string;
  showActionButton?: boolean;
  /** Marks the confirm button as destructive. */
  danger?: boolean;
}

export function presentDialogModal({
  title,
  dialog,
  size = 'sm',
  aktionButtonLabel,
  cancelButtonLabel,
  cancelErrorMessage = 'CANCEL',
  showActionButton = true,
  danger = false,
}: DialogModalProps): Promise<void> {
  return new Promise((resolve, reject) => {
    Modal.confirm({
      title,
      content: dialog,
      okText: aktionButtonLabel ?? 'OK',
      cancelText: cancelButtonLabel ?? 'Cancel',
      width: sizeToWidth[size],
      okButtonProps: showActionButton ? { danger } : { style: { display: 'none' } },
      onOk: () => {
        resolve();
      },
      onCancel: () => reject(new Error(cancelErrorMessage)),
    });
  });
}
